import { render, staticRenderFns } from "./CardCollectingItems.vue?vue&type=template&id=3973d638&scoped=true"
import script from "./CardCollectingItems.vue?vue&type=script&lang=js"
export * from "./CardCollectingItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3973d638",
  null
  
)

export default component.exports